import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function formatPhoneNumber(e164: string): string {
  if (!e164) return ''
  try {
    const parsed = parsePhoneNumberFromString(e164)
    if (parsed) {
      // US numbers are stored nationally and displayed without the "+1"
      // prefix (matching legacy). All other countries keep their country
      // code so they're visible and searchable on the list page.
      return parsed.country === 'US'
        ? parsed.formatNational()
        : parsed.formatInternational()
    }
  } catch {
    // unparseable — fall through
  }
  return e164
}
